import React from 'react';
import Navbar from '../navBar/NavBar';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Layout({ children }) {
    return (
        <div className="flex flex-col min-h-screen bg-zinc-200">
            <Navbar />
            <ToastContainer position="top-right" autoClose={5000} closeOnClick className="custom-toast"/>
            <main className="flex-grow">
                <div className='container mx-auto px-4 my-8'>
                    {children}
                </div>
            </main>
        </div>
    );
}

export default Layout;